var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CreateEngineWorker } from "../insole-web-common/src/engine/worker-interface.js";
const workerUrl = "/engine/engine-worker.js";
const engineModuleUrl = "/engine/wasm";
const engineDataFileUrl = "/engine/wasm/data.asar";
export function CreateEngine(name) {
    return CreateEngineWorker(workerUrl, engineModuleUrl, engineDataFileUrl, name);
}
const importScaleMap = {
    mm: 0.1,
    cm: 1,
    m: 100,
};
export function ImportFootScanMesh(engine, data) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        return yield engine.ImportMesh(data.format, data.fileBytes, {
            scale: importScaleMap[(_a = data.importUnits) !== null && _a !== void 0 ? _a : "cm"],
            axes: data.importAxes,
            generateNormals: true,
            centerToOrigin: true,
        });
    });
}
//# sourceMappingURL=common.js.map